<template>

  <v-card
    :disabled="!expand && !completed"
    class="col-12 pa-0 mb-4 bt-step-card"
  >
    <v-card-title>
      {{ title }}
      <v-spacer />
      <v-btn
        v-if="expand"
        :disabled="!valid || !expand"
        small
        color="primary"
        @click="complete"
      >
        Next step
      </v-btn>
    </v-card-title>
    <v-divider v-if="expand" />

    <v-card-text class="pa-0">
      <v-expand-transition>
        <v-form
          v-if="expand"
          v-model="valid"
        >
          <v-container fluid>
            <v-row justify="center">
              <v-col
                cols="12"
                md="2"
              >
                <v-select
                  v-model="value.trigger"
                  :items="triggers"
                  label="Trigger"
                  placeholder=" "
                  :rules="[v => !!v || 'Trigger is required']"
                  hide-details
                />
              </v-col>

              <v-col
                v-if="value.trigger == 'bigwin'"
                cols="12"
                md="1"
              >
                <v-text-field
                  label="Multiplier"
                  v-model="value.multiplier"
                  type="number"
                  placeholder=" "
                  :rules="[v => !!v || 'Multiplier is required']"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                md="1"
              >
                <v-text-field
                  label="Trigger Count"
                  v-model="value.trigger_count"
                  type="number"
                  placeholder=" "
                  :rules="[v => !!v || 'Trigger count is required']"
                  required
                />
              </v-col>

              <v-col
                cols="12"
                md="2"
              >
                <v-select
                  v-model="value.count_timeframe"
                  :items="periods"
                  label="Count time frame"
                  hide-details
                  clearable
                />
              </v-col>

              <v-col
                cols="12"
                md="2"
              >
                <v-select
                  v-model="value.cooldown_period"
                  :items="periods"
                  label="Count cooldown period"
                  hide-details
                  clearable
                />
              </v-col>

              <v-col
                cols="12"
                md="2"
              >
                <v-checkbox
                  label="Continuous"
                  v-model="value.continuous"
                />
              </v-col>
            </v-row>

            <fieldset
              v-if="value.trigger == 'deposit'"
              class="trigger-min-deposit-group"
            >
              <legend>
                Min. deposit
                <v-hover v-slot="{ hover }">
                  <v-icon :color="hover ? 'success': ''" @click="addMinDeposit()">mdi-plus-circle-outline</v-icon>
                </v-hover>
              </legend>

              <v-row
                class="ma-0 pb-3"
                justify="center"
              >
                <v-card
                  v-for="(o,k) in min_deposits"
                  :key="'trigger-min-dep-' + k"
                  class="ma-2"
                  style="width: 300px;"
                >
                  <v-card-text class="pa-2">
                    <v-hover v-slot="{ hover }">
                      <v-icon
                        @click="removeMinDeposit(k)"
                        class="min-deposit-close" style="z-index: 5"
                        :color="hover ? 'error' : ''"
                      >
                        mdi-minus-circle-outline
                      </v-icon>
                    </v-hover>
                    <v-row class="ma-0">
                      <v-text-field
                        label="Min"
                        v-model="min_deposits[k].min"
                        type="number"
                        placeholder=" "
                        :rules="[v => !!v || 'Amount is required']"
                        required
                        class="col-7"
                        hide-details
                      />
                      <v-select
                        v-model="min_deposits[k].currency"
                        :items="min_deposits[k].currency ? [min_deposits[k].currency, ...currenciesMinDep] : currenciesMinDep"
                        label="Currency"
                        placeholder=" "
                        class="col-5"
                        :rules="[v => !!v || 'Currency is required']"
                        hide-details
                      />
                    </v-row>

                  </v-card-text>
                </v-card>

                <v-card
                  v-if="min_deposits.length == 0"
                  class="my-2 mx-auto"
                  style="width: 100px;"
                >
                  <v-card-text
                    class="text-center"
                    @click="addMinDeposit()"
                    style="line-height: 60px; cursor:pointer;"
                    v-ripple
                  >
                    <v-hover v-slot="{ hover }">
                      <v-icon :color="hover ? 'success': ''" large>mdi-plus-circle-outline</v-icon>
                    </v-hover>
                  </v-card-text>
                </v-card>
              </v-row>
            </fieldset>


            <fieldset
              v-if="value.trigger == 'game_bet' || value.trigger == 'bigwin'"
              class="trigger-min-deposit-group"
            >
              <legend>
                Min. Bet
                <v-hover v-slot="{ hover }">
                  <v-icon :color="hover ? 'success': ''" @click="addMinBet()">mdi-plus-circle-outline</v-icon>
                </v-hover>
              </legend>


              <v-autocomplete
                v-model="value.game_id"
                :items="games"
                :loading="loadingGames"
                :disabled="loadingGames"
                label="Game"
                item-text="name"
                item-value="game_id"
                placeholder=" "
                class="mx-8 mb-3"
                :rules="[v => !!v || 'Game is required']"
                hide-details
                auto-select-first
              />


              <v-row
                class="ma-0 pb-3"
                justify="center"
              >
                <v-card
                  v-for="(o,k) in min_bet"
                  :key="'trigger-min-dep-' + k"
                  class="ma-2"
                  style="width: 300px;"
                >
                  <v-card-text class="pa-2">
                    <v-hover v-slot="{ hover }">
                      <v-icon
                        @click="removeMinBet(k)"
                        class="min-deposit-close" style="z-index: 5"
                        :color="hover ? 'error' : ''"
                      >
                        mdi-minus-circle-outline
                      </v-icon>
                    </v-hover>
                    <v-row class="ma-0">
                      <v-text-field
                        label="Min"
                        v-model="min_bet[k].min"
                        type="number"
                        placeholder=" "
                        :rules="[v => !!v || 'Amount is required']"
                        required
                        class="col-7"
                        hide-details
                      />
                      <v-select
                        v-model="min_bet[k].currency"
                        :items="min_bet[k].currency ? [min_bet[k].currency, ...currenciesMinDep] : currenciesMinDep"
                        label="Currency"
                        placeholder=" "
                        class="col-5"
                        :rules="[v => !!v || 'Currency is required']"
                        hide-details
                      />
                    </v-row>

                  </v-card-text>
                </v-card>

                <v-card
                  v-if="min_bet.length == 0"
                  class="my-2 mx-auto"
                  style="width: 100px;"
                >
                  <v-card-text
                    class="text-center"
                    @click="addMinBet()"
                    style="line-height: 60px; cursor:pointer;"
                    v-ripple
                  >
                    <v-hover v-slot="{ hover }">
                      <v-icon :color="hover ? 'success': ''" large>mdi-plus-circle-outline</v-icon>
                    </v-hover>
                  </v-card-text>
                </v-card>
              </v-row>
            </fieldset>


          </v-container>
        </v-form>
      </v-expand-transition>
    </v-card-text>
  </v-card>

</template>

<style lang="scss">

  .trigger-min-deposit-group legend {
    margin-left: 30px;
  }

  .trigger-min-deposit-group {
    border: thin solid #e1e0e0;
  }

  .min-deposit-close {
    position: absolute;
    right: 3px;
    top: 3px;
  }

  .v-card.v-card--disabled .v-card__title {
    background: #cbcbcb;
  }

  .v-card.v-card--disabled.bt-step-card {
    border-left-color: gray;
  }

  .v-card.bt-step-card {
    border-left: 4px solid #4caf50;
  }

</style>

<script>

  import { filter, map, includes, uniq } from 'lodash'
  import { API } from '@/utils/api'

  export default {

    props: {
      step: {},
      value: {},
      next: {},
      extvalid: {},
      exteditable: {},
      extcompleted: {},
      title: {},
      expand: { default: () => false },
    },

    data: () => ({
      // valid: false
      loadingGames: false,
      games: [],
      min_deposits: [],
      min_bet: [],
      triggers: [
        { value: 'register', text: 'Register' },
        { value: 'deposit', text: 'Deposit' },
        { value: 'verification', text: 'Verification' },
        { value: 'game_bet', text: 'Game Bet' },
        { value: 'bigwin', text: 'BigWin' },
        { value: 'kyc_verification', text: 'KYC Verification' },
      ],
      periods: [
        { text: 'Daily', value: 'daily' },
        { text: 'Weekly', value: 'weekly' },
        { text: 'Monthly', value: 'monthly' },
        { text: 'Weekdays', value: 'weekdays' },
        { text: 'Month days', value: 'month_days' },
        { text: 'Once', value: 'once' },
      ],
    }),

    methods: {

      complete () {
        this.completed = true

        this.next(this.step)
      },

      addMinDeposit () {
        if (!this.min_deposits) {
          this.min_deposits = []
        }

        this.min_deposits.push({ currency: this.currenciesMinDep[0] })
      },
      removeMinDeposit (j) {
        if (!this.min_deposits) {
          this.min_deposits = []
        }

        this.min_deposits.splice(j, 1)
      },

      addMinBet () {
        if (!this.min_bet) {
          this.min_bet = []
        }

        this.min_bet.push({ currency: this.currenciesMinBet[0] })
      },
      removeMinBet (j) {
        if (!this.min_bet) {
          this.min_bet = []
        }

        this.min_bet.splice(j, 1)
      },
      loadGames () {
        if (this.loadingGames) return

        this.loadingGames = true
        // let entity_id = this.project

        return API.call('/$v/game/list.json', {
          all: true,
          short: true
        }).then(resp => {
          this.games = resp.data
        }).catch(e => {
        }).finally(() => {
          this.loadingGames = false
        })
      },
    },

    computed: {
      currenciesMinDep () {
        return filter(this.$store.state.auth.currencies, o => !includes(this.selectedMinDepCurrencies, o))
      },
      selectedMinDepCurrencies () {
        return filter(map(this.min_deposits, o => o.currency), o => !!o)
      },
      currenciesMinBet () {
        return filter(this.$store.state.auth.currencies, o => !includes(this.selectedMinBetCurrencies, o))
      },
      selectedMinBetCurrencies () {
        return filter(map(this.min_bet, o => o.currency), o => !!o)
      },

      valid: {
        get () {
          return this.extvalid
        },
        set (v) {
          this.$emit('update:extvalid', v)
        }
      },
      editable: {
        get () {
          return this.exteditable
        },
        set (v) {
          this.$emit('update:exteditable', v)
        }
      },
      completed: {
        get () {
          return this.extcompleted
        },
        set (v) {
          this.$emit('update:extcompleted', v)
        }
      },
    },

    watch: {
      'min_deposits': function () {
        this.value.min_deposits = this.min_deposits
      },
      'min_bet': function () {
        this.value.min_bet = this.min_bet
      },
      'value.trigger': function () {
        this.value.min_deposits = this.min_deposits = []
        this.value.multiplier = null

        if ((this.value.trigger === 'game_bet' || this.value.trigger === 'bigwin') && this.games.length == 0) {
          this.loadGames()
        }
      },
      expand (v) {
        this.editable = true
      },
    }
  }
</script>

